  <template>
  <div class="about-section">
    <div class="movie-about">
      <img src="../../assets/Home/VIDEO.png" alt="">
    </div>
    <div class="about-home">
      <div class="text-about">
        <h2>معرفی صرافی دیجیتال دریک</h2>
        <p>
          در دریک با توجه به حجم معاملات برای شما ۷ سطح کاربری در نظر گرفته می شود و با سطح های بالاتر می توانید از
          جوایز
          و آموزش های تخصصی صرافی دریک استفاده نمایید
        </p>
        <div class="about-btn">
          <button v-if="$route.path === '/'" class="blue-btn">مشاهده سطح ها</button>
          <a class="link-about">
            <img class="tv-vector" src="../../assets/Home/tv.png" alt="">
            پخش ویدیو
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-about-home-section"
}
</script>

<style lang="scss" scoped>
.about-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  direction: rtl;
  align-items: center;
  gap: 70px;
  //height: 690px !important;
  margin-bottom: 60px;

  .about-home {
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: end;
    flex-grow: 4;
    flex-basis: 100px;

    .about-btn{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      flex-wrap: wrap;


      a{
        display: ruby;
        font-size: clamp(12px , 2vw , 16px);
      }

      .link-about {
        display: flex;
        gap: 10px;
        cursor: pointer;
        align-items: center;
      }
      .tv-vector{
        width: 18px;
        height: 15px;
      }
    }

    .text-about{
      width: 50%;
      color: #FBFBFD;
      display: flex;
      flex-direction: column;
      gap: 30px;
      text-align: right;
      align-items: start;

      button{
        width: 190px;
        height: 36px;
        cursor: pointer;
      }

      h2{
        font-size: clamp(16px , 2vw , 24px);
      }

      p{
        font-size: clamp(14px , 2vw , 16px);
      }
    }

  }

  .movie-about {
    display: flex;
    justify-content: end;
    flex-grow: 1;
    cursor: pointer;
    height: 525px;
  }
}

@media (max-width: 992px) {
  .movie-about{
    justify-content: center !important;
    width: 90%;
  }

  .movie-about img{
    width: 90%;
  }

  .about-home{
    justify-content: center !important;
    align-items: center !important;
  }
}


@media (max-width: 400px){
  .about-section{
    padding: 1rem;
  }

.about-home{
  padding: 1rem;
  width: 100%;

}
  .text-about{
    width: 100% !important;
  }
}
</style>